// Imports
var ___HTML_LOADER_IMPORT_0___ = new URL("./assets/images/profile-image.png", import.meta.url);
// Module
var code = `<template>
	<div class="page-app">
		<comp-theme-toggle></comp-theme-toggle>
		<comp-theme-picker show.bind="false"></comp-theme-picker>
		<comp-navigation show-only-external="true" ref="compNavigation" nav-items.bind="navItems" drag-nav.delegate="startDrag(\$event)" nav-item-click.delegate="onNavClick(\$event)"></comp-navigation>

		<main class="main-content">
			<div class="bg-grid"></div>

			<!-- Section - Hero -->
			<section ref="sectionHero" class="section hero">

				<div class="profile">
					<div class="profile-image">
						<img src="${___HTML_LOADER_IMPORT_0___}" alt="Johann Bajada">
					</div>
					<div>
						<h1 class="m-bottom-16 title">Hi, I am <span class="highlight">Johann Bajada.</span></h1>
						<!-- <p class="sub-title m-bottom-6">Senior Front-end Developer with 5+ years of experience building large-scale web applications.</p> -->
						<!-- <p class="sub-title">Xaghra, Malta</p> -->

						<div class="contacts m-top-16">

							<div class="item">
								<div class="link" click.trigger="downloadCv()">
									<comp-icon class="icon" icon="contact-download" width="18" height="18"></comp-icon>
									<span class="item-text">CV</span>
								</div>
							</div>

							<div class="item">						
								<div class="link" click.trigger="openLink('https://www.linkedin.com/in/johann-bajada')">
									<comp-icon class="icon" icon="contact-linkedin" width="18" height="18"></comp-icon>
									<span class="item-text">/johann-bajada</span>
								</div>
							</div>

							<div class="item">
								<div class="link" click.trigger="openLink('mailTo:johannbajada44@gmail.com')">
									<comp-icon class="icon" icon="contact-mail" width="18" height="18"></comp-icon>
									<span class="item-text">johannbajada44@gmail.com</span>
								</div>
								<div class="copy">
									<comp-icon class="icon-copy \${copiedText ? 'copied' : ''}" icon="clipboard" width="12" height="12" click.trigger="copyToClipboard('johannbajada44@gmail.com')"></comp-icon>
									<span class="copy-text" if.bind="copiedText">copied!</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>			

			<!-- Section - About -->
			<section ref="sectionAbout" class="section about">
				<h2 class="m-bottom-16">About</h2>
				<p class="text">I'm <span class="highlight">Johann Bajada</span>, a front-end developer from Xaghra, Malta, 
					with 5+ years of experience turning designs into polished, performant web apps. 
					My go-to stack is <span class="highlight">TypeScript</span>, Aurelia JS, and recently <span class="highlight">Angular</span>, but I'm always up for learning whatever the project needs. <br><br>
					I geek out over complex CSS puzzles, and those little subtle micro-animations interactive details that make the UI feel alive. 
					At the end of the day, I care about writing clean code, shipping accessible products, and making the web a little more <span class="highlight">delightful</span>, one pixel at a time.</p>
				
				<!-- <div class="spotify-playlist" if.bind="isPlaylistShowing">	
					<iframe style="border-radius:12px" src="https://open.spotify.com/embed/playlist/5ABiGsbPS39aqGYVKzkBrP?utm_source=generator&theme=0" 
						width="100%" height="152" frameBorder="0" allowfullscreen="" 
						allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>
				</div> -->
			</section>

			<!-- Section - Experience -->
			<section ref="sectionExperience" class="section experience">
				<h2 class="m-bottom-16">Experience</h2>

				<div class="jobs">
					<div class="job">
						<div class="date">July 2025 - Present</div>
						<div class="details">
							<p class="company">Senior Front-end Developer · RightShip</p>
							<p class="job-info">Building front-end features, reusable component and page architectures, reviewing code across teams, and evaluating new technologies/processes for adoption.</p>
						</div>
					</div>

					<div class="job">
						<div class="date">Sep 2022 - July 2025</div>
						<div class="details">
							<p class="company">Front-end Developer · RightShip</p>
							<p class="job-info">Built and maintained front-end features with TypeScript, Aurelia/Angular, and SASS. Delivered responsive, accessible UIs alongside designers and back-end engineers.</p>
						</div>
					</div>

					<div class="job">
						<div class="date">May 2021 - Sep 2022</div>
						<div class="details">
							<p class="company">Junior Tech Designer · Thynk Software Ltd</p>
							<p class="job-info">Translated UI/UX designs into front-end components, built prototypes, and implemented responsive layouts.</p>
						</div>
					</div>
				</div>
			</section>

			<!-- Section - Skills -->
			<section ref="sectionSkills" class="section skills">
				<h2 class="m-bottom-16">Skill Set</h2>
				
				<div class="skills-container m-bottom-32">
					<template repeat.for="skill of mainSkills">
						<div class="card">
							<comp-icon class="icon" icon="skill-\${skill.icon}" width="25" heigth="25"></comp-icon>
							<p class="skill-name">\${skill.name}</p>
						</div>
					</template>
				</div>


				<!-- Other -->
				<p class="others-title m-bottom-12">Other</p>
				<div class="skills-container others">

					<template repeat.for="skill of otherSkills">
						<div class="card">
							<comp-icon class="icon" icon="skill-\${skill.icon}" width="25" heigth="25"></comp-icon>
							<p class="skill-name">\${skill.name}</p>
						</div>
					</template>
				</div>
			</section>
		</main>
	</div>
</template>
`;
// Exports
export default code;